import { Component, OnInit, Input, ViewChild, ElementRef, ChangeDetectorRef, OnDestroy, AfterViewInit, EventEmitter, Output, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Modalconfig, ContentBlockType, DefaultLanguageId } from 'src/app/shared/constants';
import { cloneDeep, debounce, forEach, isUndefined, reject, each, findIndex, merge, filter } from 'lodash';
import { Subscription } from 'rxjs';
import { SessionStorageService } from 'src/app/shared/services/session-storage/session-storage.service';
import { sessionProfile, profileRoles } from 'src/app/shared/interfaces/sessionStorageModel';
import { moveItemInArray, CdkDragDrop } from '@angular/cdk/drag-drop';
import { CommonHttpService } from 'src/app/shared/services/common-http/common-http.service';
import { Container, CopyContentExists } from 'src/app/shared/model/container.models';
import { MessageService } from 'src/app/shared/services/message/message.service';
import $ from 'jquery';
import * as screenfull from 'screenfull';
import { isFirefox, isEdge } from '../../utils/browser.util';
import { AddPageComponent } from 'src/app/playbook-editor/shared/components/add-page/add-page.component';
import { PlaybookCommunicationService } from 'src/app/playbook-editor/shared/services/playbook-communication.service';
import { UtilService } from 'src/app/playbook-editor/shared/services/utils/util.service';
import { SendIframeUrlService } from '../../services/send-iframe-url/send-iframe-url.service';
@Component({
    selector: 'app-template-editor',
    templateUrl: './template-editor.component.html',
    styleUrls: ['./template-editor.component.scss'],
    standalone: false
})
export class TemplateEditorComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input('containers') container: Container;
  @Input('playbookId') playbookId;
  @Input('pageTemplate') pageTemplate;
  @Input('returnUrl') returnUrl;
  @Output() updateTemplateManifest = new EventEmitter();
  companyId;
  isParentPageInDraftMode = false;
  @ViewChild('contentBox') contentBox: ElementRef;
  defaultLanguageId = DefaultLanguageId;
  public resourceCounts = 0;
  public isCurrentPageInDraftMode = false;
  private addPageModalRef: BsModalRef;
  private scrollEnable = true;
  private throttle;
  private subscribed = null;
  private pageIdSubscribed: Subscription = null;
  private sectionIdSubscriber: Subscription = null;
  private contRatingsSubscription: Subscription;
  private modalSubscription: Subscription[] = [];
  private navContainerUpdateSubscription: Subscription;
  private showContentBoxSubscription: Subscription;
  public playbookLanguages: any;
  private selectedPageId;
  private selectedSectionId;
  public updateSearchResult;
  loggedInProfile: sessionProfile;
  isServerProcess = false;
  private routeSubscription: Subscription;
  public list = {
    sections: [],
    pages: [],
    draftSection: [],
    draftPages: []
  };
  isTouchDevice = false;
  public contentBoxShow = false;
  public isCopyPasteContentExist = new CopyContentExists();
  public isContentBoxOpened = false;
  public profileRolesEnum = profileRoles;
  public screenfull = screenfull;
  draggableWithDragText = {
    type: ContentBlockType.Text
  };
  draggableWithDragTab = {
    type: ContentBlockType.Tabs
  };
  draggableWithDragImage = {
    type: ContentBlockType.Image
  };
  draggableWithDragAudio = {
    type: ContentBlockType.Audio
  };
  draggableWithDragVideo = {
    type: ContentBlockType.Video
  };
  draggableWithDragChallenge = {
    type: ContentBlockType.Challenge
  };
  draggableWithDragCopyPaste = {
    type: ContentBlockType.CopyPaste
  };
  vBuilderRedirectURl: string;
  languageId: number;
  confirmationModalRef: BsModalRef;
  confModalSubsciber: Subscription;
  draftModalRef: BsModalRef;
  draftModalSubsciber: Subscription;
  modalRef: BsModalRef;
  public isFireFox = isFirefox();
  public isEdge = isEdge();
  contentRow: any;
  constructor(
    private router: Router,
    private commonHttpService: CommonHttpService,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private modalService: BsModalService,
    private ref: ChangeDetectorRef,
    private commService: PlaybookCommunicationService,
    private sessionStorageService: SessionStorageService,
    private utilService: UtilService,
    private messageService: MessageService,
    private sendIframeUrlService: SendIframeUrlService
  ) { }

  ngOnInit() {
    this.fillDetails();
    if (('ontouchstart' in window)) {
      this.isTouchDevice = true;
    }
  }
  /**
   * To close translation modal on browser back event
   */
 @HostListener('window:popstate', ['$event'])
 onPopState(event) {
  window.location.reload();
 }

  fillDetails() {
    this.loggedInProfile = this.sessionStorageService.getLoggedInProfileDetail();
    this.languageId = +this.activatedRoute.snapshot.queryParams.languageId || this.defaultLanguageId;
    this.vBuilderRedirectURl = this.activatedRoute.snapshot.queryParams.r || null;
    // to set page title according to selected section on initial loading
    this.routeSubscription = this.activatedRoute.params.subscribe(data => {
      if (data.sectionId) {
        if (this.container.containers) {
          this.container.containers.forEach((container: Container) => {
            if (container.id === data.sectionId) {
              document.title = container.title;
            }
          });
        }
      }
    });
    this.throttle = debounce(this.onScrollContent, 10);

    /**
     * To seperate sections and pages from containers
     */
    if (this.container.containers && this.container.containers.length > 0) {
      this.seperateContainer();
      this.pageIdSubscribed = this.commService.getCurrentPageId().subscribe(pageId => {
        this.selectedPageId = pageId;
      });
      this.sectionIdSubscriber = this.commService.getCurrentSectionId().subscribe(sectionId => {
        this.selectedSectionId = sectionId;
      });
    }
    if (this.commService.currentSectionId != null) {
      this.selectedSectionId = this.commService.currentSectionId;
    }
    if (this.commService.currentPageId != null) {
      this.selectedPageId = this.commService.currentPageId;
    }
    this.isCopyPasteContentExist = this.commService.getCopyContentExists();

    this.getResourcesCounts();

    /**
     * Subscriber to handle edit and deletion of section from nav
     */
    this.navContainerUpdateSubscription = this.commService.getNavContainerUpdate().subscribe(container => {
      if (this.container.id === container.container.parentContainerId) {
        if (container.container.isDeleted) {
          this.container.containers = reject(this.container.containers, (cont) => {
            return cont.id === container.container.id;
          });
          this.seperateContainer();
        } else {
          this.editContainer(container.container);
        }
      }
    });

    this.commService.getPlaybookLanguages().subscribe(
      playbookLanguages => {
        this.playbookLanguages = playbookLanguages;
      }
    );

    this.showContentBox();
    this.isServerProcessFunc();
  }

  ngAfterViewInit() {
    const self = this;
    /**
     * Malihu-scroll bar is removed and instead of that register a scroll event of the container.
     */
    $(`#content-${this.container.id}`).on('scroll', () => {
      if (self.scrollEnable === true) {
        this.throttle($(`#content-${this.container.id}`));
      }
    });

    /** Handle deep-link scroll; IDs/state are initialized in ngOnInit. */
    if (this.selectedPageId === this.container.id) {
      let SelectedElement = document.getElementById('section-' + this.selectedSectionId);

      if (SelectedElement !== null) {
        setTimeout(() => {
          SelectedElement = document.getElementById('section-' + this.selectedSectionId);
          this.scrollEnable = false;
          $(`#content-${this.container.id}`).animate({ scrollTop: this.getSectionTop(this.selectedSectionId) }, 300, () => {
            this.scrollEnable = true;
          });
        }, 100);
      }
    }
    this.isCopyPageExists();
  }

  showContentBox() {
    this.showContentBoxSubscription = this.commService.getSelectedContentBox().subscribe(isContentBoxShow => {
      this.contentBoxShow = isContentBoxShow;
    });
  }
  /**
   * To seperate sections and pages to display
   */
  seperateContainer() {
    this.list.sections = this.container.containers.filter(x => {
      return (x.type === 2 && !x.isDraftMode);
    });
    this.list.pages = this.container.containers.filter(x => {
      return (x.type === 1 && !x.isDraftMode);
    });

    this.list.draftSection = this.container.containers.filter(x => (x.type === 2 && x.isDraftMode && !x.isDeleted));

    this.list.draftPages = this.container.containers.filter(x => (x.type === 1 && x.isDraftMode && !x.isDeleted));

  }
  /**
   * To set selected section in sidebar
   */
  setPageSectionsOn(selectedId) {
    this.container.containers.forEach((cont, index) => {
      if (cont.type === 2 && cont.id === selectedId) {
        cont.on = true;
        document.title = cont.title;
      } else if (cont.type === 2) {
        cont.on = false;
      }
    });
    if (this.selectedPageId === this.container.id) {
      this.ref.detectChanges();
    }
  }

  /**
   * To check which section in viewport and set its section on along with change of location in browser url.
   */
  private onScrollContent = (elem) => {
    const x = elem.find('section.content_section');
    let next = false;
    let first = true;
    for (const el of x) {
      const selected = +(el.getAttribute('id')).split('section-')[1];
      const top = el.getBoundingClientRect().top;
      if (!next && first && (top - 44 >= 0 || el.scrollHeight >= window.innerHeight - Math.ceil(top))) {
        first = false;
        next = true;
        if (selected !== this.selectedSectionId) {
          this.commService.sendCurrentSectionId(selected);
          this.setPageSectionsOn(selected);
        }
      }
    }
  }

  /**
   * To scroll on top of container when clicked on name of container
   */
  scrollToTop(containerId) {
    const id = containerId ? containerId : this.container.id;
    const scrollElement = document.getElementById('content-' + id).querySelectorAll('.content_section')[0];
    if (!isUndefined(scrollElement)) {
      const scrollId = +scrollElement.id.split('section-')[1];
      this.scrollEnable = false;
      $(`#content-${id}`).animate({ scrollTop: this.getSectionTop(scrollId) }, 300, () => {
        this.scrollEnable = true;
      });
      this.setPageSectionsOn(scrollId);
      this.commService.sendCurrentSectionId(scrollId);
    }
    if (id !== this.selectedPageId) {
      this.commService.sendCurrentPageId(id);
    }

  }

  /**
   * To set section to top in content for reading on click of section link in sidebar
   */
  showSection(cont: Container) {
    document.title = cont.title;
    if (cont.parentContainerId === this.selectedPageId) {
    } else {
      this.commService.sendCurrentPageId(this.container.id);
    }
    this.commService.sendCurrentSectionId(cont.id);
    this.scrollEnable = false;
    $(`#content-${this.container.id}`).animate({ scrollTop: this.getSectionTop(cont.id) }, 300, () => {
      this.scrollEnable = true;
    });
    setTimeout(() => {
      this.setPageSectionsOn(cont.id);
    });
  }

  /**
   * This will return the top position of the section.
   */
  getSectionTop(sectionId) {
    const section = $('section#section-' + sectionId);
    if (section.offset()) {
      const sectionTop = section.offset().top;
      const contentTop = $('#content-' + this.container.id).scrollTop();
      let top = 0;
      if ($('.card-playbook').offset()) {
        top = $('.card-playbook').offset().top;
      }
      const scrollTop = sectionTop + contentTop - 44 - top;
      return scrollTop;
    }
    return null;
  }

  /**
   * To turn open children pages of perticular page
   */
  setContainer(containerId, isParent) {
    $('.text-editor-menu-bar').hide();
    if (containerId == null) {
      document.title = this.commService.Playbook.title;
    } else {
      if (isParent && containerId) {
        this.scrollToTop(containerId);
      }
    }
    if (!isParent) {
      this.setPageSectionsOn(-1);
      this.commService.sendCurrentPageId(containerId);
      this.commService.sendCurrentSectionId(null);
    }
  }

  /**
   * To get resource count for selected container resources
   */
   getResourcesCounts() {
    if(this.container.resourceFolders) {
      this.container.resourceFolders.map((folder) => {
        folder.resources.map((resource) => {
          // For Links
          if (resource.type === 1 && resource.linkUrl && resource.linkUrl.toString().trim() !== '') {
            this.resourceCounts++;
          } else if ((resource.type === 2 || resource.type === 0) && resource.asset && resource.assetId) {
            this.resourceCounts++;
          }
        });
      });
    }
    this.container.resources.map((resource) => {
      // For Links
      if (resource.type === 1 && resource.linkUrl && resource.linkUrl.toString().trim() !== '') {
        this.resourceCounts++;
      } else if ((resource.type === 2 || resource.type === 0) && resource.asset && resource.assetId) {
        this.resourceCounts++;
      }
    });
  }

  /**
   * To toggle resource drawer for this container
   */
  toggleDrawer() {
    this.commService.ToggleResourcesOn();
    this.commService.sendSelectedContentBox(false);
    this.commService.sendSelectedContentBlockId(null);
    this.commService.sendSelectedRowId(null);
  }


  /**
   * To redirect to editor module
   */
  redirectToViewer() {
    setTimeout(() => {
      const route = `${window.location.pathname.replace('/playbookeditor', '/playbook')}?languageId=${this.languageId}${this.vBuilderRedirectURl ?
        '&r=' + this.vBuilderRedirectURl : ''}`;
      this.router.navigateByUrl(route);
    }, 200);
  }

  onContainerItemDrop(e: CdkDragDrop<any[]>) {
    const items = [];
    each(e.container.element.nativeElement.querySelectorAll('li'), (page) => {
      items.push(+page.id.replace('page-', ''));
    });
    moveItemInArray(items, e.previousIndex, e.currentIndex);
    const orderObj = items.map((id, index) => {
      return Object.assign({}, { id, order: index });
    });

    const reqObj = {
      playbookId: this.commService.Playbook.id,
      companyId: this.commService.Playbook.companyId,
      type: 1,
      orders: orderObj
    };
    let list = cloneDeep(this.list);
    if (!this.container.isCurrentPageInDraftMode) {
      forEach(this.list.pages, (cont: Container) => {
        cont.orderBy = items.indexOf(cont.id);
      });
    } else {
      forEach(this.list.draftPages, (cont: Container) => {
        cont.orderBy = items.indexOf(cont.id);
      });
    }
    this.commonHttpService.post({
      uri: '/api/Containers/ReOrderContainers',
      object: reqObj
    }).subscribe(res => {
      list = null;
    }, (error) => {
      this.list = list;
      list = null;
    });
  }

  /**
   * To handle reorder of containers
   * @param e cdkDragDrop event handler
   */
  onSectionItemDrop(e: CdkDragDrop<any[]>) {
    const items = [];
    each(e.container.element.nativeElement.querySelectorAll('li'), (page) => {
      items.push(+page.id.replace('section-', ''));
    });
    moveItemInArray(items, e.previousIndex, e.currentIndex);
    const orderObj = items.map((id, index) => {
      return Object.assign({}, { id, order: index });
    });
    const reqObj = {
      playbookId: this.commService.Playbook.id,
      companyId: this.commService.Playbook.companyId,
      pageTemplateId: this.pageTemplate.id,
      type: 1,
      orders: orderObj
    };
    let list = cloneDeep(this.list);
    if (!this.container.isCurrentPageInDraftMode) {
      forEach(this.list.sections, (cont: Container) => {
        cont.orderBy = items.indexOf(cont.id);
      });
    } else {
      forEach(this.list.draftSection, (cont: Container) => {
        cont.orderBy = items.indexOf(cont.id);
      });
    }
    this.commonHttpService.post({
      uri: '/api/Containers/ReOrderContainers',
      object: reqObj
    }).subscribe(res => {
      list = null;
    }, (error) => {
      this.list = list;
      list = null;
    });
  }

  /**
   * To handle add section popup
   */
  addSection() {
    const container = new Container();
    container.type = 2;
    container.iconClass = null;
    container.parentContainerId = this.container.id;
    const initialState = {
      container,
      verb: 'Add',
      playbookId: this.commService.Playbook.id,
      companyId: this.commService.Playbook.companyId,
      profileId: this.loggedInProfile.id,
      pageId: this.container.id,
      draftMode: this.isCurrentPageInDraftMode,
      languageId: this.languageId,
      pageTemplateId: this.pageTemplate.id
    };
    this.addPageModalRef = this.modalService.show(AddPageComponent,
      Object.assign({ initialState }, { class: 'custom-modal ' }, Modalconfig));

    this.modalSubscription.push(
      this.addPageModalRef.content.addContainer.subscribe(data => {
        this.container.containers.push(data);
        this.seperateContainer();
        this.unsubscribeModelsSub();
      }),
      this.addPageModalRef.content.pasteContainer.subscribe(async data => {
        this.updateTemplateManifest.emit('');
        this.unsubscribeModelsSub();
      })
    );
  }

  /**
   * To handle edit page popup
   * @param cont update container
   */
  editContainer(cont) {
    const container = new Container();
    merge(container, cont);
    const initialState = {
      container,
      verb: 'Edit',
      playbookId: this.commService.Playbook.id,
      companyId: this.commService.Playbook.companyId,
      profileId: this.loggedInProfile.id,
      pageId: this.container.id,
      draftMode: this.isCurrentPageInDraftMode,
      languageId: this.languageId,
      pageTemplateId: this.pageTemplate.id
    };
    this.addPageModalRef = this.modalService.show(AddPageComponent,
      Object.assign({ initialState }, { class: 'custom-modal ' }, Modalconfig));
    this.modalSubscription.push(
      this.addPageModalRef.content.removeContainer.subscribe(data => {
        this.container.containers = reject(this.container.containers, (eachCont) => eachCont.id === container.id);
        this.seperateContainer();
        this.unsubscribeModelsSub();
      }),
      this.addPageModalRef.content.updateContainer.subscribe((data: Container) => {
        if (data.isPoolingNeeded) {
          this.getPlaybookManifest(data.isDraftMode);
        } else {
          if (this.languageId === this.defaultLanguageId) {
            this.container.containers = reject(this.container.containers, (eachCont) => eachCont.id === data.id);
            this.container.containers.push(data);
          } else {
            const containerIndex = findIndex(this.container.containers, (eachCont) => eachCont.id === data.id);
            this.container.containers[containerIndex].title = data.title;
          }
        }
        this.seperateContainer();
        this.unsubscribeModelsSub();
      })
    );
  }

  /*
     * show add content block menu.
     */
  showBlockMenuFunc() {
    if (!this.isServerProcess) {
      this.contentBoxShow = !this.contentBoxShow;
      this.isCopyPasteContentExist = this.commService.getCopyContentExists();
      this.commService.sendSelectedContentBox(this.contentBoxShow);
      this.commService.sendSelectedContentBlockId(null);
      this.commService.sendSelectedRowId(null);
      // TODO: patch inner page shows double content box
      this.isContentBoxOpened = true;
    }
  }

  /**
   * To open mail for playbook support
   */
  openSupportMail() {
    window.open('mailto:support@vplaybook.com', '_self');
  }

  isServerProcessFunc() {
    this.commService.getServerProcess().subscribe(isServerProcess => this.isServerProcess = isServerProcess);
  }

  onDragStart(e, isCopyPaste = false) {
    if(isCopyPaste) {
      this.contentRow = this.isCopyPasteContentExist.contentType;
    } else {
      this.contentRow = null;
    }
  }
  onDragEnd(e) {
    this.contentRow = null;
    const d = $('.dndDragover');
    this.contentBoxShow = false;
    this.utilService.clearAllBorderClasses();
  }

  onDragMoved(e) {
    const d = $('.dndDragover');
    d.first().removeClass('dndDragover');
    this.contentBoxShow = false;
    this.utilService.clearAllBorderClasses();
    this.contentBoxShow = true;
  }

  onDrag(e: DragEvent, isRowCopied = false) {
    if (this.contentBoxShow) {
      this.commService.sendSelectedContentBox(false);
    }
    if (!this.isFireFox && !this.isEdge) {
      const ui = {
        offset: {
          top: e.y,
          left: e.x
        },
      };
      this.contentBoxShow = false;
      const t = $(e.target);
      const d = $('.dndDragover');
      if (e.x && e.y) {
        if (d.length === 0) {
          this.utilService.clearAllBorderClasses();
        }
        if (d.length > 1) {
          d.first().removeClass('dndDragover');
        }
        if (d.hasClass('norow')) {
          this.utilService.applyBorderClass(d, 'top-hover');
        } else {
          if (d.length > 0) {
            this.utilService.detectAndAddHoverClass(d, ui, t);
          }
        }
      }
    }
  }

  clearSelectedEditor(isHideContentBox) {
    this.commService.sendSelectedContentBlockId(null);
    this.commService.sendSelectedRowId(null);
    if (isHideContentBox) {
      this.commService.sendSelectedContentBox(false);
    }
  }

  // this function will check if the page is current tab is not
  checkForCurrentContainer(container) {
    return this.selectedPageId === container.id ? true : false;
  }

  getPlaybookManifest(isDraftMode?: boolean, undoRedoSectionData?: any) {
    if (this.playbookId) {
      this.commonHttpService.get<any>(
        {
          uri: `/api/Playbooks/GetFullPlaybookManifest?playbookId=${this.playbookId}&languageId=${this.languageId === this.defaultLanguageId
            ? null : this.languageId}`
        })
        .subscribe(response => {
          const playbookData = JSON.parse(response.json);
          this.commService.Playbook = playbookData;
          if (undoRedoSectionData) {
            this.setPageSectionsOn(undoRedoSectionData.sectionId ? undoRedoSectionData.sectionId : -1);
            this.commService.sendCurrentSectionId(undoRedoSectionData.sectionId ? undoRedoSectionData.sectionId : null);
            this.commService.sendCurrentPageId(undoRedoSectionData.pageId ? undoRedoSectionData.pageId : -1);
            const url = `/playbookeditor/${undoRedoSectionData.playbookId}${undoRedoSectionData.pageId
              ? '/page/' + undoRedoSectionData.pageId + '/section/' + undoRedoSectionData.sectionId : ''}?languageId=${this.languageId}${this.vBuilderRedirectURl ? '&r=' + this.vBuilderRedirectURl : ''}`;
            this.location.go(url);
            this.sendIframeUrlService.sendUrlToParent(url);
          } else if (!isDraftMode) {
            this.setPageSectionsOn(-1);
            this.commService.sendCurrentPageId(-1);
            this.commService.sendCurrentSectionId(null);
            this.container.isCurrentPageInDraftMode = isDraftMode;
            this.isCurrentPageInDraftMode = isDraftMode;
            this.commService.setDraftStatus({
              pageId: this.container.id,
              isPageDraftMode: false
            });
          } else if (isDraftMode) {
            this.setPageSectionsOn(-1);
            this.commService.sendCurrentPageId(-1);
            this.commService.sendCurrentSectionId(null);
            this.commService.setDraftStatus({
              pageId: this.container.id,
              isPageDraftMode: isDraftMode
            });
          }
        });
    }
  }

  unsubscribeModelsSub() {
    this.modalSubscription.forEach((sub) => {
      sub.unsubscribe();
    });
    this.modalSubscription = [];
  }

  /**
   * returns playbook viewer's url
   */
  copyViewerLinkToClipboard(): string {
    return window.location.href.replace('/playbookeditor', '/playbook');
  }
  notify(event: string): void {
    this.messageService.showSuccessMessage('URL successfully copied to your clipboard.');
  }

  isCopyPageExists() {
    this.commonHttpService.get({
      uri: `/api/Playbooks/IsCopyContentExists?userId=${this.loggedInProfile.id}&playbookId=${this.playbookId}&pageTemplateId=${this.pageTemplate.id}`,
    }).subscribe(
      (copyContentData: CopyContentExists) => {
        this.commService.setCopyContentExists(copyContentData);
      });
  }

  ngOnDestroy() {
    if (this.modalSubscription.length > 0) {
      this.unsubscribeModelsSub();
    }
    if (this.navContainerUpdateSubscription) {
      this.navContainerUpdateSubscription.unsubscribe();
    }
    if (this.sectionIdSubscriber) {
      this.sectionIdSubscriber.unsubscribe();
    }
    if (this.pageIdSubscribed) {
      this.pageIdSubscribed.unsubscribe();
    }
    if (this.subscribed) {
      this.subscribed.unsubscribe();
    }
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
    if (this.contRatingsSubscription) {
      this.contRatingsSubscription.unsubscribe();
    }
    if (this.showContentBoxSubscription) {
      this.showContentBoxSubscription.unsubscribe();
    }
  }
}
